// extracted by css-extract-rspack-plugin
export default {"container":"_842c15be"};